/**
 * 사용자의 행동 가이드 모음
 */
export default {
  'try-again-later': '잠시 후 다시 시도해주세요.',
}
